"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsetClass = exports.BaseSubset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const fetch_utils_1 = require("../fetch.utils");
const GetByIdGrouped_1 = __importDefault(require("../get/GetByIdGrouped"));
const GetByIdGroupedLive_1 = __importDefault(require("../get/GetByIdGroupedLive"));
const observable_1 = require("../get/observable");
class BaseSubset {
    constructor(origin, apiKey, dataset) {
        this.origin = origin;
        this.apiKey = apiKey;
        this.dataset = dataset;
        this.getManyAdvancedLive = (params) => {
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_ADVANCED + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
    }
}
exports.BaseSubset = BaseSubset;
class SubsetClass extends BaseSubset {
    constructor(origin, apiKey, dataset, setId, subset) {
        super(origin, apiKey, dataset);
        this.setId = setId;
        this.subset = subset;
        this.getManyById = async (subsetIds) => {
            const params = {
                dataset: this.dataset,
                setIds: subsetIds.map(() => this.setId),
                subset: this.subset,
                subsetIds,
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_BY_ID;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        this.getManyByIdLive = (subsetIds) => {
            const params = {
                dataset: this.dataset,
                setIds: subsetIds.map(() => this.setId),
                subset: this.subset,
                subsetIds,
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY_BY_ID + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.apiKey, url);
        };
        this.getAll = async (startAfter) => {
            const params = {
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                startAfter,
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        this.getAllLive = (startAfter) => {
            const params = {
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                startAfter,
                fieldName: [],
                fieldValue: [],
                operator: [],
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getByField = async (fieldName, fieldValue, startAfter) => {
            const params = {
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                fieldName,
                fieldValue,
                startAfter,
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_MANY;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        this.getAllUpdatedAfter = async (updatedAfter) => {
            const params = {
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                updatedAfter,
            };
            const url = this.origin + interfaces_1.ApiRoutes.GET_UPDATED_AFTER;
            return await (0, fetch_utils_1.wrappedFetch)(this.apiKey, url, Object.assign({}, params));
        };
        this.getTopBySubColIdLive = (subsetId, orderBy = ['createdOn'], orderByDir = ['desc'], startAfter, limit) => {
            const params = {
                dataset: this.dataset,
                subset: this.subset,
                fieldName: ['uid', 'parentCol'],
                fieldValue: [subsetId, this.dataset],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                limit,
                orderBy,
                orderByDir,
            };
            return this.getManyAdvancedLive(params);
        };
        this.subsetId = (subsetId) => new ExactSubset(this.origin, this.apiKey, this.dataset, this.setId, this.subset, subsetId);
    }
}
exports.SubsetClass = SubsetClass;
class ExactSubset {
    constructor(origin, apiKey, dataset, setId, subset, subsetId) {
        this.origin = origin;
        this.apiKey = apiKey;
        this.dataset = dataset;
        this.setId = setId;
        this.subset = subset;
        this.subsetId = subsetId;
        this.get = () => {
            if (!this.setId) {
                throw Error('Setid must be set');
            }
            return GetByIdGrouped_1.default.get({
                origin: this.origin,
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                subsetId: this.subsetId,
                apiKey: this.apiKey,
            });
        };
        this.getLive = () => {
            if (!this.setId) {
                throw Error('Setid must be set');
            }
            return (0, rxjs_1.from)(GetByIdGroupedLive_1.default.get({
                origin: this.origin,
                apiKey: this.apiKey,
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                subsetId: this.subsetId,
            })).pipe((0, rxjs_1.switchMap)((inner) => inner));
        };
    }
}
